
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchTrackAndTraceConfigById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eshopTrackAndTraceConfigById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tagColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headerColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"footerColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buttonColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabledRating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selectedTagColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"progressBarColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tagBackgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"footerBackgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buttonBackgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headerBackgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selectedTagBackgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"favicon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileBackgroundImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopBackgroundImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":571}};
    doc.loc.source = {"body":"query fetchTrackAndTraceConfigById($id: ID!) {\n  eshopTrackAndTraceConfigById(id: $id) {\n    title\n    tagColor\n    linkColor\n    headerColor\n    footerColor\n    buttonColor\n    primaryColor\n    enabledRating\n    selectedTagColor\n    progressBarColor\n    tagBackgroundColor\n    footerBackgroundColor\n    buttonBackgroundColor\n    headerBackgroundColor\n    selectedTagBackgroundColor\n    logo {\n      id\n      url\n    }\n    favicon {\n      id\n      url\n    }\n    mobileBackgroundImage {\n      id\n      url\n    }\n    desktopBackgroundImage {\n      id\n      url\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["fetchTrackAndTraceConfigById"] = oneQuery(doc, "fetchTrackAndTraceConfigById");
        
